module.exports = __webpack_public_path__ + "static/img/gzh.bc4232e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gzh.png
// module id = Xq3r
// module chunks = 6